import React from 'react'
import InfoIcon from './icons/InfoIcon'
import SuccessIcon from './icons/SuccessIcon'
import ErrorIcon from './icons/ErrorIcon'
import CloseIcon from './icons/CloseIcon'

const alertStyle = {
    backgroundColor: '#ffffff',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
    padding: '0px',
	gap: '8px',
    borderRadius: '8px',
	overflow: 'hidden',
    justifyContent: 'flex-start',
	paddingRight: '16px'
}
const borderStyle = {
	width: '4px',
	minHeight: '40px',
	backgroundColor: '#FAC83B'
}
const contentStyle = {
	display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '0px',
    gap: '8px',
    flex: 'none',
    flexGrow: 0
}
const spanStyle = {
	fontFamily: 'Ubuntu',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    color: '#33323D',
}
const buttonStyle = {
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    color: '#FFFFFF',
	maxHeight: '16px'
}

const AlertTemplate = ({ message, options, style, close }) => {
	const customBorderStyle = { ...borderStyle };
	customBorderStyle.backgroundColor = options.type == 'success' ? '#00A184' :
								  		options.type == 'error' ? '#FF5978' :
								  		'#FAC83B';

    return <div style={{ ...alertStyle, ...style }} className='app-alert'>
		<div className='app-alert-border' style={customBorderStyle}></div>
		<div className='app-alert-content' style={contentStyle}>
			{options.type === 'info' && <InfoIcon />}
			{options.type === 'success' && <SuccessIcon />}
			{options.type === 'error' && <ErrorIcon />}

			<span style={spanStyle}>{message}</span>

			<button onClick={close} style={buttonStyle}>
				<CloseIcon />
			</button>
		</div>
	</div>
}
  
export default AlertTemplate